




















































/* General */
import Vue from 'vue'
import RegistrationLayout from '@/layouts/registration-layout.vue'
import MainContainer from '@/layouts/main-container.vue'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import TimeAssistant from '@/helpers/time-assistant'
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { IRegistrationOutputCompleteUser } from '@/api/types/response.types'

/* API */
import RegistrationAPI from '@/api/modules/registration.api'
import { IRegistrationInputCompleteUser } from '@/api/types/request.types'

export default Vue.extend({
  name: 'UserRegistrationComplete',

  metaInfo(): any {
    return {
      title: 'Complete user registration',
    }
  },

  components: {
    RegistrationLayout,
    MainContainer,
  },

  data() {
    return {
      RouteAssistant,
      tokenErrorMessage: '',
      userRegistered: false,
      isLoading: true,
      isSubmitting: false,
      completeUserData: {} as IRegistrationOutputCompleteUser,
      formData: {
        encryptedUserToken: '',
        name: '',
        password: '',
        passwordConfirm: '',
        timezone: '',
        viaGoogleAuth: false,
        acceptTerms: false,
        acceptEmailList: false,
      } as IRegistrationInputCompleteUser,
      formRules: {
        name: [
          {
            validator: (rule: any, value: any, callback: any) => {
              if (value && value.trim() !== '') {
                callback()
              } else {
                callback(new Error('Name is required'))
              }
            },
            trigger: 'blur',
          },
        ],
        password: [
          {
            validator: (rule: any, value: any, callback: any) => {
              // @ts-ignore
              if (this.completeUserData.viaGoogleAuth) {
                callback()
              }

              if (value.length < 8) {
                callback(new Error('Password must be at least 8 characters'))
              } else if (!/\d/.test(value)) {
                callback(new Error('Password must contain a digit (0-9)'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        passwordConfirm: [
          {
            validator: (rule: any, value: any, callback: any) => {
              // @ts-ignore
              if (this.completeUserData.viaGoogleAuth) {
                callback()
              }
              // @ts-ignore
              if (value !== this.formData.password) {
                callback(new Error('Password must match'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        timezone: [{ required: true, message: 'Timezone is required' }],
      },
    }
  },

  computed: {
    disableSubmit(): boolean {
      return !this.formData.acceptTerms
    },
    hasTokenErrorMessage(): boolean {
      return (
        this.tokenErrorMessage !== undefined &&
        this.tokenErrorMessage.length > 0
      )
    },
  },

  async created() {
    this.isLoading = true
    await this.getCompleteUserData()
    this.isLoading = false
  },

  methods: {
    async submitForm() {
      // @ts-ignore
      this.$refs.form.validate(valid => {
        if (valid) {
          this.completeUser()
        }
      })
    },

    async completeUser() {
      this.isSubmitting = true
      try {
        await RegistrationAPI.post_CompleteUser(this.formData)
        this.userRegistered = true
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        this.isSubmitting = false
      }
    },

    async getCompleteUserData() {
      try {
        const viaGoogleAuth = this.$route.query.via_google_auth === 'true'
        this.completeUserData = await RegistrationAPI.get_CompleteUser(
          viaGoogleAuth,
          TextAssistant.urlTokenCleaner(this.$route.query.token),
        )
        this.formData.timezone = TimeAssistant.guessTimezoneID()
        this.formData.viaGoogleAuth = this.completeUserData.viaGoogleAuth
        this.formData.encryptedUserToken = this.completeUserData.encryptedUserToken
      } catch (error) {
        this.tokenErrorMessage = error.data.message
      }
    },
  },
})
